;(function () {


    function PayPalPaymentController() {

        var _this = this

        this.payPalContainerId = "#paywall-button-container"
        this.payAwareness = "#paywall-awareness-container"
        this.payAgainElement = "#paywall-doublePayment-notice"
        this.payAgainButton = "#paywall-doublePayment-order-again"
        this.payAgainNotButton = "#paywall-doublePayment-order-not-again"

        this.isInitialized = false;

        this.cartConfig = window.Creaton.Cart.Configuration;

        this.init = function () {
            if(_this.avoidDoublePaymentCheck()) {
                _this.buildPaypalPaymentButton();
            }
        }

        /**
         * validate an order again to ensure its payed
         * @param orderId
         */
        this.validateOrder = function (orderId) {
            try {
                $(_this.payPalContainerId).addClass('paywall-button-container--loading');
                $.post('paypal/order/validate/'+orderId, (result) => {
                    result = JSON.parse(result);
                    if(result.success === true) {
                        _this.showPayedBeforeElement(orderId);
                    } else {
                        _this.buildPaypalPaymentButton();
                    }
                })
            }
            catch (error) {

                _this.buildPaypalPaymentButton();
            }
        }

        /**
         * show an element to user to notice for a payment before on same cart items
         * @param orderId
         */
        this.showPayedBeforeElement = function (orderId) {
            // remove loading and show notice
            $(_this.payPalContainerId).removeClass('paywall-button-container--loading');
            $(_this.payAgainElement).show();
            // add events to order again the same items
            $(_this.payAgainButton).click(() => {
                $(_this.payAgainElement).hide();
                _this.buildPaypalPaymentButton();
            });
            // add events to not order again the same items and fullfill the last order
            $(_this.payAgainNotButton).click((e) => {
                e.preventDefault();
                // pay awareness are the checkboxes which must set to fullfill the last order so mails could sent again
                $(_this.payAwareness).css('opacity', '0');
                $(_this.payAwareness).show();
                $('#js-payment-consent').prop( "checked", true );
                $('#js-cancellation-consent').prop( "checked", true );
                // necessary to fullfill the last order to ensure transmittion to evalanche
                $('#sample-order-payment-id').val(orderId);
                // show loading and then submit the form
                $(_this.payPalContainerId).addClass('paywall-button-container--loading');
                $('.js-sample-order__paywall-form').submit();
            });
        }

        /**
         * avoidDoublePaymentCheck
         * @return {boolean}
         */
        this.avoidDoublePaymentCheck = function () {
            const lastPaymentJsonString = localStorage.getItem(_this.cartConfig.lastPayment);
            const currentOrderJsonString = localStorage.getItem(_this.cartConfig.cart);
            // if a last payment was done with same browser
            if (lastPaymentJsonString && currentOrderJsonString) {
                const lastPayment = JSON.parse(lastPaymentJsonString);
                const currentOrder = JSON.parse(currentOrderJsonString);
                // check if last payment was made for same cart items
                if (_this.equalCheck(lastPayment.cart, currentOrder)) {
                    // validate order by api call if its valid return false
                    _this.validateOrder(lastPayment.orderId);
                    return false;
                }
            }
            return true;
        }

        /**
         * check if an object is equal to another
         * @param x
         * @param y
         * @return {false|*|boolean}
         */
        this.equalCheck = function deepEqual(x, y) {
            const ok = Object.keys, tx = typeof x, ty = typeof y;
            return x && y && tx === 'object' && tx === ty ? (
                ok(x).length === ok(y).length &&
                ok(x).every(key => deepEqual(x[key], y[key]))
            ) : (x === y);
        }

        /**
         * use the paypal SDK to add the payment buttons to the page
         * https://developer.paypal.com/sdk/js/reference/
         * The payment buttons are only active, if all of them are checked
         */
        this.buildPaypalPaymentButton = function () {
            // remove loading and show pay awareness checkboxes
            $(_this.payPalContainerId).removeClass('paywall-button-container--loading');
            $(_this.payAwareness).show();
            var paypalContainer = $(_this.payPalContainerId);

            this.isInitialized = true;
            paypal.Buttons({
                onInit: function (data, actions) {

                    // Enable or disable the button and the gray filter (visibly disabled)
                    var enableButtons = function () {
                        if(document.querySelectorAll('.js-payment-consent:checked').length === 2) {
                            actions.enable();
                            paypalContainer.removeClass('paywall-button-container--inactive')
                        } else {
                            actions.disable();
                            paypalContainer.addClass('paywall-button-container--inactive')
                        }
                    }

                    // Check button state initially (important for reload) or if the checkbox changes
                    enableButtons();
                    document.querySelectorAll('.js-payment-consent').forEach(
                        function (checkbox) {
                            checkbox.addEventListener('change', function (event) {
                                enableButtons();
                            });
                        }
                    );

                },

                // This function sets up the details of the transaction, including the amount and line item details.
                createOrder: function (data, actions) {
                    return actions.order.create({
                        //capture payment from buyer
                        intent: 'CAPTURE',
                        // https://developer.paypal.com/docs/api/orders/v2/#definition-payee_payment_method_preference
                        payee_payment_method_preference: 'IMMEDIATE_PAYMENT_REQUIRED',
                        payer: {
                            // Adds dynamic user data from the form (used as placeholder)
                            name: {
                                given_name: paypalContainer.data('paymentForename'),
                                surname: paypalContainer.data('paymentLastname')
                            },
                            "email_address": paypalContainer.data('paymentEmail')
                        },
                        purchase_units: [{
                            amount: {
                                // amount and price are checked via backend validation after submit (paywall.price)
                                value: '9.90',
                                currency_code: "EUR"
                            }
                        }]
                    });
                },

                // see https://developer.paypal.com/docs/api/orders/v2/#orders_capture
                // This function captures the funds from the transaction.
                onApprove: function (data, actions) {
                    return actions.order.capture().then(function(details) {
                        // save last order to prevent double payments
                        const cartItems = localStorage.getItem(_this.cartConfig.cart);
                        const paymentInfo = {
                            orderId: details.id,
                            cart: JSON.parse(cartItems)
                        }
                        localStorage.setItem(_this.cartConfig.lastPayment, JSON.stringify(paymentInfo));
                        // show loading
                        $(_this.payPalContainerId).addClass('paywall-button-container--loading');

                        $('#sample-order-payment-id').val(details.id);
                        $('.js-sample-order__paywall-form').submit();
                    });
                },
                onCancel: function (data) {
                    // Currently not used
                },
                onError: function (err) {
                    console.error(err);
                    // For example, redirect to a specific error page or show error message and let user try again
                    //window.location.href = "/your-error-page-here";
                }
            }).render(_this.payPalContainerId);

        }

        _this.init()
    }

    window.Creaton = window.Creaton || {}

    window.Creaton.PayPalPaymentController = PayPalPaymentController

})()


$(document).ready(function () {
    var $payPalContainer = $("#paywall-button-container")
    if ($payPalContainer.length) {
        new window.Creaton.PayPalPaymentController()
    }
})
